(() => {
  "use strict";

  // ====== 保存用キーと簡易ヘルパー ======
  const STORAGE_KEY = "no:numerology";
  const saveSession = (obj) => sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));

  // ====== 画像マップ（CDN直指定：1〜9 + 11/22/33）======
  const IMG = {
    1: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_01.jpg?v=1760259315",
    2: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_02.jpg?v=1760259315",
    3: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_03.jpg?v=1760259315",
    4: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_04.jpg?v=1760259315",
    5: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_05.jpg?v=1760259315",
    6: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_06.jpg?v=1760259315",
    7: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_07.jpg?v=1760259315",
    8: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_08.jpg?v=1760259315",
    9: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_09.jpg?v=1760259315",
    11: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_11.jpg?v=1760259315",
    22: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_22.jpg?v=1760259315",
    33: "https://cdn.shopify.com/s/files/1/0640/2372/4203/files/numerology_33.jpg?v=1760259315",
  };

  // IMG定義のすぐ下に追加
  Object.values(IMG).forEach((url) => {
    const img = new Image();
    img.src = url;
  });

  // ====== 数字系 ======
  const sumDigits = (num) =>
    String(num)
      .split("")
      .reduce((acc, ch) => acc + Number(ch || 0), 0);

  // マスターナンバー保持
  const reduceToSingleDigit = (num, opt = { keepMaster: true }) => {
    let result = num;
    const steps = [num];
    const isMaster = (n) => opt.keepMaster && (n === 11 || n === 22 || n === 33);
    while (result >= 10 && !isMaster(result)) {
      result = sumDigits(result);
      steps.push(result);
    }
    return { result, steps };
  };

  const calcNumerology = ({ year, month, day }, opt = { keepMaster: true }) => {
    const yd = sumDigits(year);
    const md = sumDigits(month);
    const dd = sumDigits(day);
    const currentSum = yd + md + dd;
    return {
      current: reduceToSingleDigit(currentSum, opt),
      past: reduceToSingleDigit(day, opt),
      future: reduceToSingleDigit(md + dd, opt),
    };
  };

  // ====== 日付系 ======
  const isValidDate = (y, m, d) => {
    const dt = new Date(y, m - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
  };
  const daysInMonth = (y, m) => new Date(y, m, 0).getDate();

  // ====== DOM参照 ======
  const els = {
    year: document.getElementById("numerology-year"),
    month: document.getElementById("numerology-month"),
    day: document.getElementById("numerology-day"),
    results: document.getElementById("results"),
    list: document.querySelector(".cm-numerology__result__list"),
    //
    showYear: document.getElementById("numerology-show-year"),
    showMonth: document.getElementById("numerology-show-month"),
    showDay: document.getElementById("numerology-show-day"),
  };

  // ====== セレクト生成 ======
  const fillSelect = (el, values, labelFn) => {
    const frag = document.createDocumentFragment();
    el.innerHTML = "";
    const ph = document.createElement("option");
    ph.value = "";
    ph.textContent = "";
    ph.disabled = true;
    ph.selected = true;
    frag.appendChild(ph);
    values.forEach((v) => {
      const opt = document.createElement("option");
      opt.value = v;
      opt.textContent = labelFn ? labelFn(v) : String(v);
      frag.appendChild(opt);
    });
    el.appendChild(frag);
  };

  // 値表示（ミラー）を同期
  const syncDisplay = () => {
    els.showYear && (els.showYear.textContent = els.year.value || "");
    els.showMonth && (els.showMonth.textContent = els.month.value || "");
    els.showDay && (els.showDay.textContent = els.day.value || "");
  };

  const initSelects = () => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => currentYear - i);
    fillSelect(els.year, years, (y) => y);
    fillSelect(
      els.month,
      Array.from({ length: 12 }, (_, i) => i + 1),
      (m) => m
    );
    fillSelect(els.day, [], (d) => d);

    // 変更時：日数再生成 + 表示ミラー同期
    els.year.addEventListener("change", () => {
      refreshDays();
      syncDisplay();
    });
    els.month.addEventListener("change", () => {
      refreshDays();
      syncDisplay();
    });
    // ▼ 追加：日変更で表示ミラー同期 + 結果閉じ
    els.day.addEventListener("change", () => {
      syncDisplay();
      slideUp(els.results, 100);
    });

    // ▼ デフォルト値を設定（1980年1月1日）
    els.year.value = 1980;
    els.month.value = 1;
    refreshDays(); // ← 日数選択肢を反映
    els.day.value = 1;
    syncDisplay();
  };

  const refreshDays = () => {
    const y = Number(els.year.value);
    const m = Number(els.month.value);
    if (!y || !m) {
      fillSelect(els.day, [], (d) => d);
      // 結果を閉じる
      slideUp(els.results, 100);
      syncDisplay();
      return;
    }
    const max = daysInMonth(y, m);
    const prev = els.day.value;
    fillSelect(
      els.day,
      Array.from({ length: max }, (_, i) => i + 1),
      (d) => d
    );
    if (prev && Number(prev) <= max) els.day.value = prev;

    // 年/月が変わったので結果を閉じる
    slideUp(els.results, 100);
    syncDisplay();
  };

  // ====== 結果DOMまるごと生成 ======
  const buildResultList = (pastNum, currentNum, futureNum) => {
    // listコンテナをクリア
    els.list.innerHTML = "";

    const isEnglish = window.location.pathname.startsWith('/en/');

    const items = [
      { title: isEnglish ? "Past<br>Number" : "過去数", num: pastNum },
      { title: isEnglish ? "Current<br>Number" : "現在数", num: currentNum },
      { title: isEnglish ? "Future<br>Number" : "未来数", num: futureNum },
    ];

    const frag = document.createDocumentFragment();

    items.forEach(({ title, num }) => {
      // 画像キー：マスターナンバー画像がある場合はそのまま、無ければ1桁へ丸め
      const key = IMG[num] ? num : reduceToSingleDigit(num, { keepMaster: false }).result;

      const dl = document.createElement("dl");

      const dt = document.createElement("dt");
      dt.className = "cm-numerology__result__list__title";
      dt.innerHTML = title;

      const dd = document.createElement("dd");
      dd.className = "cm-numerology__result__list__img";

      const a = document.createElement("a");
      a.href = isEnglish
        ? `/en/pages/numerology-${key}`
        : `/pages/numerology-${key}`;

      const img = document.createElement("img");
      img.src = IMG[key];
      img.alt = String(num); // altはマスターナンバー（11/22/33）もそのまま表示
      img.width = 406;
      img.height = 506;
      img.loading = "lazy";

      a.appendChild(img);
      dd.appendChild(a);
      dl.appendChild(dt);
      dl.appendChild(dd);
      frag.appendChild(dl);
    });

    els.list.appendChild(frag);
  };

  // ====== スライドダウン（heightアニメーション）======
  const slideDown = (el, duration = 600) => {
    // すでに展開済みなら一旦高さを確定（auto→px）してから再計算
    const isOpen = el.clientHeight > 0;
    el.style.overflow = "hidden";
    el.style.transition = `height ${duration}ms ease`;
    if (!isOpen) {
      el.style.height = "0px";
    } else {
      el.style.height = `${el.clientHeight}px`;
    }
    // 次フレームでターゲット高さへ
    const target = el.scrollHeight;
    requestAnimationFrame(() => {
      el.style.height = `${target}px`;
    });
    // アニメ後にautoへ戻してコンテンツ変化に追随
    const end = () => {
      el.style.transition = "";
      el.style.height = "auto";
      el.removeEventListener("transitionend", end);
    };
    el.addEventListener("transitionend", end);
  };

  // ====== スライドアップ（heightアニメーションで閉じる）======
  const slideUp = (el, duration = 600) => {
    // すでに閉じていれば何もしない
    if (!el || el.clientHeight === 0) return;

    el.style.overflow = "hidden";
    el.style.transition = `height ${duration}ms ease`;
    // 現在の高さをpxで固定してから 0 にアニメーション
    el.style.height = `${el.clientHeight}px`;
    requestAnimationFrame(() => {
      el.style.height = `0px`;
    });

    const end = () => {
      el.style.transition = "";
      // 閉じ状態を維持（次回 open で slideDown が機能するように height:0 のまま）
      el.removeEventListener("transitionend", end);
    };
    el.addEventListener("transitionend", end);
  };

  // ====== 計算トリガ（グローバル公開：HTMLのonclick="calc()" 用）======
  window.calc = () => {
    const y = Number(els.year.value);
    const m = Number(els.month.value);
    const d = Number(els.day.value);

    if (!y || !m || !d) {
      alert("⚠️ 西暦・月・日をすべて選択してください。");
      return;
    }
    if (!isValidDate(y, m, d)) {
      alert("⚠️ 実在する日付を選択してください。");
      return;
    }

    const { current, past, future } = calcNumerology({ year: y, month: m, day: d }, { keepMaster: true });

    // 結果DOM
    buildResultList(past.result, current.result, future.result);
    slideDown(els.results, 700);

    // ★ ここで保存（年月日＋数値＋“開いてる”フラグ）
    saveSession({
      y,
      m,
      d,
      nums: { past: past.result, current: current.result, future: future.result },
      open: true,
      ts: Date.now(),
    });
  };

  // ====== 初期化 ======
  document.addEventListener("DOMContentLoaded", () => {
    const saved = sessionStorage.getItem("no:numerology");

    // sessionStorage が存在しない or 中身が空の場合だけ 初期化
    if (!saved) {
      //console.log("🆕 初期化します");
      initSelects();
      return;
    }

    // ここに復元処理
    try {
      const st = JSON.parse(saved);
      //console.log("🔙 sessionStorageから復元");
      initSelects(); // セレクト枠は再生成
      if (st.y) els.year.value = st.y;
      if (st.m) {
        els.month.value = st.m;
        refreshDays({ silent: true });
      }
      if (st.d) els.day.value = st.d;

      // ▼ 復元後にミラー同期
      syncDisplay();

      if (st.open && st.nums) {
        buildResultList(st.nums.past, st.nums.current, st.nums.future);
        els.results.style.height = "auto";
      }
    } catch (e) {
      console.warn("復元失敗", e);
      initSelects();
    }
  });
})();
